import React from 'react'

export default function WizardHatIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M2.8 10.15L4.67469 5.59562C5.04656 4.69219 5.72031 3.94844 6.58219 3.48906L9.79562 1.77625C10.0647 1.63187 10.3753 1.87906 10.2987 2.17437L9.485 5.28937C9.46094 5.37906 9.45 5.47094 9.45 5.565C9.45 5.70281 9.47625 5.84062 9.52875 5.96969L11.2 10.15H6.66969L6.92781 9.37562L7.81156 9.08031C7.95375 9.03219 8.05 8.89875 8.05 8.74781C8.05 8.59687 7.95375 8.46344 7.81156 8.41531L6.92781 8.12L6.6325 7.23625C6.58438 7.09625 6.45094 7 6.3 7C6.14906 7 6.01562 7.09625 5.9675 7.23844L5.67219 8.12219L4.78844 8.4175C4.64625 8.46562 4.55 8.59906 4.55 8.75C4.55 8.90094 4.64625 9.03438 4.78844 9.0825L5.67219 9.37781L5.93031 10.1522H2.8V10.15ZM7.51625 4.49531C7.49219 4.42312 7.42656 4.375 7.35 4.375C7.27344 4.375 7.20781 4.42312 7.18375 4.49531L7.03719 4.93719L6.59531 5.08375C6.52312 5.10781 6.475 5.17344 6.475 5.25C6.475 5.32656 6.52312 5.39219 6.59531 5.41625L7.03719 5.56281L7.18375 6.00469C7.20781 6.07687 7.27344 6.125 7.35 6.125C7.42656 6.125 7.49219 6.07687 7.51625 6.00469L7.66281 5.56281L8.10469 5.41625C8.17687 5.39219 8.225 5.32656 8.225 5.25C8.225 5.17344 8.17687 5.10781 8.10469 5.08375L7.66281 4.93719L7.51625 4.49531ZM2.1 11.2H11.9C12.2872 11.2 12.6 11.5128 12.6 11.9C12.6 12.2872 12.2872 12.6 11.9 12.6H2.1C1.71281 12.6 1.4 12.2872 1.4 11.9C1.4 11.5128 1.71281 11.2 2.1 11.2Z"
        fill="currentColor"
      />
    </svg>
  )
}
